export default __webpack_public_path__ + "static/media/info.3e1f3a4e.png";